export const CHART_COLORS = {
  blue: '#3b82f6',
  emerald: '#10b981'
};

export const WIDGET_CARD_CLASS = 'bg-white rounded-xl border border-gray-100 flex flex-col h-full';

export const widgetFooterLinkClass =
  'inline-flex items-center text-xs font-medium text-gray-500 hover:text-gray-900 transition-colors';
